import { useState, useEffect, useMemo } from "react"
import { useHistory } from 'react-router-dom'
import api from "../components/api";
import { rotulo, sleep, rotuloEnviado, cor, corEnviado } from '../components/functions'
import { useVerificaDesafioContext } from '../context/verificaDesafioContext'

import MaterialReactTable from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import LoaderIcon from "react-loader-icon";

import "@fortawesome/fontawesome-free/css/all.min.css";


import ModalPerfilAnual from '../modals/perfilAnual'
import ModalPerfilAnualCorp from '../modals/perfilAnualCorp'
import ModalValidacao from '../modals/validacao'
import ModalEmailCorrecao from '../modals/emailCorrecao'

import ModalEmailVer from '../modals/emailVer'
import { useEmailVerContext } from '../context/emailVerContext'

import Badge from 'react-bootstrap/Badge';

import Pendencias from '../components/Pendencias'


const PerfilAnual = () => {


    const history = useHistory()

    const { verificaDesafio, setVerificaDesafio } = useVerificaDesafioContext()
    const { desafioEmail_id, setDesafioEmail_id } = useEmailVerContext()
    
    const [perfilAnual_id, setPerfilAnual_id] = useState()
    const [carregando, setCarregando] = useState('block')
    const [resultado, setResultado] = useState([])
    const [resultadoRede, setResultadoRede] = useState()

    const [uf, setUF] = useState('')
    const [resultadoUF, setResultadoUF] = useState([])
    const [regiao, setRegiao] = useState('')
    const [resultadoRegiao, setResultadoRegiao] = useState([])

    const [adesao_institucional_id, setAdesaoInstitucionalId] = useState()

    const [ano, setAno] = useState(new Date().getFullYear() -1)
    const [anoProps, setAnoProps] = useState()
    const [anos, setAnos] = useState()
    const [adesao_institucional_id_ref, setAdesaoInstitucionalIdRef] = useState(0)

    const [totalPreenchimentos, setTotalPreenchimentos] = useState(0)
    
    const [totalVerificados, setTotalVerificados] = useState(0)
    const [resultadoVerificados, setResultadoVerificados] = useState([])

    var [resultadoCorrecoes, setResultadoCorrecoes] = useState([])
    var [totalCorrecoes, setTotalCorrecoes] = useState(0)
    
    const [totalNotificacoes, setTotalNotificacoes] = useState(0)

    const correcoes = () => {

        var dataPost = {

            desafio: 'PerfilAnual'

        }

        api.post('desafioValidaCorrecoes', dataPost).then((result) => {

            
            setResultadoCorrecoes(result.data)
            setTotalCorrecoes(result.data.length)

        }).catch((err) => {

            console.log(err.response)

        })


    }
    

    const carregaRegiao = () => {

        api.get('regiao').then((result) => {
    
            setResultadoRegiao(result.data.map((rs) =>
                    
                <option value={rs.regiao}>{rs.regiao}</option>
        
            ))
    
        }).catch((err) => {
    
            console.log(err.response)
    
        })
    
    }
    
    
    const carregaUF = () => {
    
        api.get('uf').then((result) => {
    
            //console.log(result.data)
    
            setResultadoUF(result.data.map((rs) =>
                    
                <option value={rs.uf_codigo}>{rs.uf_codigo}</option>
        
            ))
    
        }).catch((err) => {
    
            console.log(err.response)
    
        })
    
    }
    
    
    

    async function carregaRede() {

        await api.get(`adesaoInstitucionalRede`).then((result) => {

            setResultadoRede(result.data.map((rs) =>

                <option value={rs.adesao_institucional_id} key={rs.adesao_institucional_id}>{rs.razao_social}</option>
            
            ))

        })

    }



    async function carregaAnos() {

        var anoTemp = []

        var anoAtual = new Date().getFullYear() -1

        for (var x = anoAtual; x >= 2008; x--) {

            var anoJson = {

                ano: x,

            }

            anoTemp.push(anoJson)

        }

        setAnos(anoTemp.map((rs) =>
        
            <option value={rs.ano}>{rs.ano}</option>
        
        ))

    }


    

    const columnsCorrecoes = useMemo(
        () => [
          {
            accessorKey: 'nome_fantasia', //access nested data with dot notation
            header: 'Nome Fantasia',
          },
          {
            accessorKey: 'cnpj',
            header: 'CNPJ',
          },
          {
            accessorKey: 'anoPerfil',
            header: 'Ano',
          },
          
          {
            accessorKey: 'situacao',
            header: 'Situação',
            Cell: ({ renderedCellValue, row }) => (
            
                 
                //<span className={`label label-${ renderedCellValue == 'C' || renderedCellValue ==  'V' ? 'success' : renderedCellValue == 'A' ? 'warning' : renderedCellValue == 'I' ? 'primary' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : renderedCellValue == 'P' ? 'danger' : 'primary' }`}>{rotuloEnviado(renderedCellValue)}</span>
                //<Badge style={{ color: 'black', backgroundColor: renderedCellValue == 'P' || renderedCellValue == 'I' ? '#ffc4ab' : renderedCellValue == 'E' ? '#fa8c90' : renderedCellValue == 'S' || renderedCellValue == null || renderedCellValue == 'C'  ? '#7edeed' : renderedCellValue == 'A' ? '#ebe7b2' : renderedCellValue == 'V' ? '#59d970' : '#839ae6'  }}>{rotuloEnviado(renderedCellValue)} </Badge>
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
                
                
            ),
            
          },
          {
            accessorKey: 'ad_upd',
            header: 'Último preenchimento',
            
          },

         

        ],
        [],
      );


    const columns = useMemo(
        () => [
          {
            accessorKey: 'nome_fantasia', //access nested data with dot notation
            header: 'Nome Fantasia',
          },
          {
            accessorKey: 'cnpj',
            header: 'CNPJ',
          },
          {
            accessorKey: 'ano',
            header: 'Ano',
          },
          {
            accessorKey: 'uf_codigo',
            header: 'UF',
          },

          {
            accessorKey: 'situacao',
            header: 'Situação',
            Cell: ({ renderedCellValue, row }) => (
            
                 
                //<span className={`label label-${ renderedCellValue == 'C' || renderedCellValue ==  'V' ? 'success' : renderedCellValue == 'A' ? 'warning' : renderedCellValue == 'I' ? 'primary' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : renderedCellValue == 'P' ? 'danger' : 'primary' }`}>{rotuloEnviado(renderedCellValue)}</span>
                //<Badge style={{ color: 'black', backgroundColor: renderedCellValue == 'P' || renderedCellValue == 'I' ? '#ffc4ab' : renderedCellValue == 'E' ? '#fa8c90' : renderedCellValue == 'S' || renderedCellValue == null || renderedCellValue == 'C'  ? '#7edeed' : renderedCellValue == 'A' ? '#ebe7b2' : renderedCellValue == 'V' ? '#59d970' : '#839ae6'  }}>{rotuloEnviado(renderedCellValue)} </Badge>
                <Badge style={{  backgroundColor: cor(renderedCellValue) }}>{rotulo(renderedCellValue)}</Badge>
                
                
            ),
            
          },
          {
            accessorKey: 'dataUltimoPreenchimento',
            header: 'Último preenchimento',
            
          },


          {
            accessorKey: 'dataHoraUltimaAuditoria',
            header: 'Última auditoria em',
          },
         


         

        ],
        [],
      );


      const carregaPerfis = () => {

        var dataPost = {

            ano: ano,
            uf: uf,
            adesao_institucional_id_ref: adesao_institucional_id_ref,
            regiao: regiao,

        }

        //console.log(dataPost)

        setCarregando('block')

        api.post('perfilAnualPend', dataPost).then((result) => {

            //console.log(result.data)
            setTotalPreenchimentos(result.data.length)
            setResultado(result.data)
            setCarregando('none')


        }).catch((err) => {

            console.log(err.response)
            setCarregando('none')

        })

      }


    

    const verificados = () => {

        var dataPost = {

            desafio: 'PerfilAnual'

        }

        api.post('desafioValidaVerificados', dataPost).then((result) => {

            //console.log(result.data, 'verificados')

            setResultadoVerificados(result.data)
            setTotalVerificados(result.data.length)

        }).catch((err) => {

            console.log(err.response)

        })


    }

    
    useEffect(() => {

        carregaRede()
        carregaAnos()
        carregaRegiao()
        carregaUF()
        

    }, [])


    useEffect(() => {

        carregaPerfis()
        correcoes()
        verificados()

    }, [ano, uf, regiao, adesao_institucional_id_ref, verificaDesafio])



    /*


    async function geraExcel() {

        

        window.toastr.success('Aguarde, gerando XLSX...')

        var dataPost = {

            ano: ano,
            uf: uf,
            adesao_institucional_id_ref: adesao_institucional_id_ref,
            regiao: regiao,

        }

        await api.post('perfilAnualPendExcel', dataPost).then((result) => {

            

            if (result.data.status == 'ok') {

                sleep(1000).then(() => {

                    //window.open(`http://apihomolog.hospitaissaudaveis.org/residuosSS.xlsx`)
                    //window.location.href = `http://172.16.1.253:3600/${result.data.arquivo}`
                    window.location.href = `${process.env.REACT_APP_API}/${result.data.arquivo}`

                })

                
            }

        }).catch((err) => {

            console.log(err.response)

        })

    }

    */



    const geraExcel = async () => {

        window.toastr.info("Aguarde...");
  
        try {


        var dataPost = {

            ano: ano,
            uf: uf,
            adesao_institucional_id_ref: adesao_institucional_id_ref,
            regiao: regiao,

        }
  
        const response = await api.post(`perfilAnualPendExcel`, dataPost, {
            responseType: "blob",
            validateStatus: (status) => true // para não cair direto no catch
        });
  
        if (response.status !== 200) {
            // ler como texto para ver o erro real
            const errorText = await response.data.text();
            console.error("Erro backend:", errorText);
            window.toastr.error("Erro ao exportar: " + errorText);
            return;
        }
  
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "perfilAnual.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
  
        window.toastr.success("Download concluído!");
        } catch (err) {
        console.error(err);
        window.toastr.error("Falha ao baixar arquivo");
        }
    };
    



    const columnsVerificados = useMemo(
        () => [
          {
            accessorKey: 'nome_fantasia', //access nested data with dot notation
            header: 'Nome Fantasia',
          },
          {
            accessorKey: 'cnpj',
            header: 'CNPJ',
          },
          {
            accessorKey: 'anoDesafio',
            header: 'Ano',
          },


          {
            accessorKey: 'perfilCorporativo',
            header: 'Tipo Perfil',
            Cell: ({ renderedCellValue, row }) => (
            
                //<span class={`label label-${ renderedCellValue == 'C' ? 'success' : renderedCellValue == 'I' ? 'warning' : renderedCellValue == 'E' ? 'danger' : renderedCellValue == 'O' ? 'info' : 'primary' }`}>{rotulo(renderedCellValue)}</span>
                <Badge style={{  backgroundColor: renderedCellValue == true ? '#baebf7' : '#d8d0f5' }}>{renderedCellValue == true ? 'Corporativo' : 'Padrão'}</Badge>
           
            ),
          },

         

        ],
        [],
      );

    return (

        <div>

                <div class='content-header'>
                    <div class='header-icon'>
                        <i class='pe-7s-gleam'></i>
                    </div>
                    <div class='header-title'>
                        <h1>Perfil Anual</h1>
                        <small>Administração</small>
                        
                    </div>
                </div>


            <ul className="nav nav-tabs">
                
                <li className="active" ><a href="#tab1" data-toggle="tab" onClick={() => {} } >Preenchimentos ({totalPreenchimentos})</a></li>
                <li ><a href="#tab2" data-toggle="tab" onClick={() => {} } >Correções ({totalCorrecoes})</a></li>
                <li ><a href="#tab3" data-toggle="tab" onClick={() => {} } >Verificados ({totalVerificados})</a></li>
                <li ><a href="#tab4" data-toggle="tab" onClick={() => {} } >Notificações ({totalNotificacoes})</a></li>

            </ul>

            <div class="tab-content">
                <div class="tab-pane fade in active" id="tab1">
                    <div class="panel-body">

                        
                    

                                <div class="col-md-12">

                                    <button type="button" class="btn btn-success" onClick={() => geraExcel()}>Exportar XLS</button>&nbsp;

                                    <br/><br/>

                                </div>


                                <div className="col-md-12">

                                    <div className="form-group">

                                        
                                        <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {setAdesaoInstitucionalIdRef(event.target.value)}} value={adesao_institucional_id_ref} >
                                            <option value="0">[Rede ou Sistema de Saúde]</option>
                                            {resultadoRede}
                                        </select>  
                                        
                                    </div>

                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">

                                        
                                        
                                        <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {setAno(event.target.value)}} value={ano} >
                                            <option value={0}>Todos os anos</option>
                                            {anos}
                                        </select>  
                                        
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">

                                        
                                        <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {setUF(event.target.value)}} value={uf} >
                                            <option value="">[UF]</option>
                                            {resultadoUF}
                                        </select>  
                                        
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">

                                        
                                        <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {setRegiao(event.target.value)}} value={regiao} >
                                            <option value="">[Região]</option>
                                            {resultadoRegiao}
                                        </select>  
                                        
                                    </div>
                                </div>

                                <div className="col-md-12" style={{ display: carregando }} >
                                    <LoaderIcon  type={"cylon"} style={{ display: carregando }} />
                                </div>

                                <div className="col-md-12" style={{ display: carregando == 'none' ? 'block' : 'none'}}>


                                    <MaterialReactTable 

                                    columns={columns} 
                                    data={resultado} 
                                    localization={MRT_Localization_PT_BR}
                                    //rowsPerPage={20}
                                    //options={options}
                                    initialState={{ density: 'compact' }}
                                    muiTableHeadCellProps={{
                                        //easier way to create media queries, no useMediaQuery hook needed.
                                        sx: {
                                        fontSize: {
                                            xs: '8px',
                                            sm: '9px',
                                            md: '10px',
                                            lg: '11px',
                                            xl: '12px',
                                        },
                                        },
                                    }}
                                    muiTableBodyCellProps={{
                                        sx: {
                                            fontSize: {
                                            xs: '8px',
                                            sm: '9px',
                                            md: '10px',
                                            lg: '11px',
                                            xl: '12px',
                                            },
                                        },
                                    }}
                                    muiTableBodyRowProps={({ row }) => ({
                                    onClick: (event) => {
                                        //console.info(event, row.original.usuario_id);
                                        //console.log(row.original, 'aqui')
                                        //navigate(`/FluxoCaixa/Vinculo/${row.original.vinculo_id}`)
                                        //window.$('.modal-MovimentoEdit').modal('show');setMovimento_id(row.original.movimento_id)
                                        //history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                                        //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setResiduo_id(row.original.residuo_id); window.$("#modalResiduos").modal('show')
                                        //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setEnergia_id(row.original.energia_id); window.$("#modalEnergia").modal('show')
                                        //categoria_adesao == 'G' ? '#modalPerfilAnualCorp' : '#modalPerfilAnual' } onClick={() => 
                                        setAdesaoInstitucionalId(row.original.adesao_institucional_id);setPerfilAnual_id(row.original.perfilAnual_id);
                                        setAnoProps(row.original.ano ? row.original.ano : row.original.anoDesafio);
                                        window.$(`${ row.original.perfilCorporativo == true ? '#modalPerfilAnualCorp' : '#modalPerfilAnual' }`).modal('show')
                                    },
                                    sx: {
                                        cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                    },
                                    })}
                                    />

                                    </div>





                    </div>
                </div>
                <div className="tab-pane fade in" id="tab4">

                    <Pendencias
                        desafio="PerfilAnual"
                        setTotalNotificacoes={setTotalNotificacoes}
                        abrirModal={(item) => {

                            setAdesaoInstitucionalId(
                                item.adesao_institucional_id
                            )

                            setPerfilAnual_id(
                                item.perfilAnual_id ??
                                item.formulario_id
                            )

                            setAnoProps(
                                item.anoPerfil ??
                                item.anoDesafio ??
                                item.ano
                            )

                            window.$(
                                '#modalPerfilAnual'
                            ).modal('show')

                        }}
                    />

                </div>
                <div className="tab-pane fade in" id="tab3">

                    <div className="panel-body">

                            <div className="col-md-12" style={{ display: carregando }} >
                                <LoaderIcon  type={"cylon"} style={{ display: carregando }} />
                            </div>
                        
                            <div className="col-md-12" style={{ display: resultadoVerificados ? 'block' : 'none'}}>

                            <MaterialReactTable 

                                columns={columnsVerificados} 
                                data={resultadoVerificados} 
                                localization={MRT_Localization_PT_BR}
                                //rowsPerPage={20}
                                //options={options}
                                initialState={{ density: 'compact' }}
                                muiTableHeadCellProps={{
                                    //easier way to create media queries, no useMediaQuery hook needed.
                                    sx: {
                                    fontSize: {
                                        xs: '8px',
                                        sm: '9px',
                                        md: '10px',
                                        lg: '11px',
                                        xl: '12px',
                                    },
                                    },
                                }}
                                muiTableBodyCellProps={{
                                    sx: {
                                        fontSize: {
                                        xs: '8px',
                                        sm: '9px',
                                        md: '10px',
                                        lg: '11px',
                                        xl: '12px',
                                        },
                                    },
                                }}
                                muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) => {
                                    
                                    //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); 
                                    //setHospClima_id(row.original.hospClima_id); window.$("#modalCertificado").modal('show')

                                    /*
                                    abreCertificado({

                                        ano: row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio,
                                        adesao_institucional_id: row.original.adesao_institucional_id,
                                        formulario_id: row.original.hospClima_id,
                                        certificacao: row.original.certificacao,
                                        origem: 'Clima',

                                    })
                                    */
                                    setAdesaoInstitucionalId(row.original.adesao_institucional_id);setPerfilAnual_id(row.original.perfilAnual_id);
                                    setAnoProps(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio);window.$(`${ row.original.perfilCorporativo == true ? '#modalPerfilAnualCorp' : '#modalPerfilAnual' }`).modal('show')

                                },
                                sx: {
                                    cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                },
                                })}

                            />


                        </div>

                    </div>

                </div>
                <div class="tab-pane fade in " id="tab2">
                    <div class="panel-body">

                        


                            <div className="col-md-12" style={{ display: carregando }} >
                                <LoaderIcon  type={"cylon"} style={{ display: carregando }} />
                                </div>

                                <div className="col-md-12" style={{ display: carregando == 'none' ? 'block' : 'none'}}>




                                    <MaterialReactTable 

                                    columns={columnsCorrecoes} 
                                    data={resultadoCorrecoes} 
                                    localization={MRT_Localization_PT_BR}
                                    //rowsPerPage={20}
                                    //options={options}
                                    initialState={{ density: 'compact' }}
                                    muiTableHeadCellProps={{
                                        //easier way to create media queries, no useMediaQuery hook needed.
                                        sx: {
                                        fontSize: {
                                            xs: '8px',
                                            sm: '9px',
                                            md: '10px',
                                            lg: '11px',
                                            xl: '12px',
                                        },
                                        },
                                    }}
                                    muiTableBodyCellProps={{
                                        sx: {
                                            fontSize: {
                                            xs: '8px',
                                            sm: '9px',
                                            md: '10px',
                                            lg: '11px',
                                            xl: '12px',
                                            },
                                        },
                                    }}
                                    muiTableBodyRowProps={({ row }) => ({
                                    onClick: (event) => {
                                        //console.info(event, row.original.usuario_id);
                                        //navigate(`/FluxoCaixa/Vinculo/${row.original.vinculo_id}`)
                                        //window.$('.modal-MovimentoEdit').modal('show');setMovimento_id(row.original.movimento_id)
                                        //history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                                        //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setResiduo_id(row.original.residuo_id); window.$("#modalResiduos").modal('show')
                                        setAdesaoInstitucionalId(row.original.adesao_institucional_id);setPerfilAnual_id(row.original.perfilAnual_id);
                                        setAnoProps(row.original.ano ? row.original.ano : row.original.anoDesafio);window.$(`${ row.original.perfilCorporativo == true ? '#modalPerfilAnualCorp' : '#modalPerfilAnual' }`).modal('show')
                                    },
                                    sx: {
                                        cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                    },
                                    })}
                                    />

                                    </div>








                    </div>
                </div>
            </div>



            <ModalPerfilAnual adesao_institucional_id={adesao_institucional_id} ano={anoProps}  formulario_id={perfilAnual_id} />
            <ModalPerfilAnualCorp adesao_institucional_id={adesao_institucional_id} ano={anoProps} formulario_id={perfilAnual_id} />
            <ModalValidacao adesao_institucional_id={adesao_institucional_id} ano={anoProps} formulario_id={perfilAnual_id} origem='PerfilAnual' correcoes={correcoes} />
            <ModalEmailCorrecao adesao_institucional_id={adesao_institucional_id} ano={anoProps} formulario_id={perfilAnual_id} origem='PerfilAnual' correcoes={correcoes} />
            <ModalEmailVer desafioEmail_id={desafioEmail_id}  />
                
                    
        </div>


    )

}


export default PerfilAnual